import { axios } from 'lib/axios';

export const googleAuthSetup = async () => {
  return await axios.post('/user/authenticator/setup');
};
